/*
 * Copyright (c) 2020 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Badge component
 *
 * @author Thais Watanabe
 */
const Badge = (props) => {
  var { color } = props;

  return (
    <span
      className={`bg-${color}-100 text-${color}-800 inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium`}
    >
      {props.children}
    </span>
  );
};

export default Badge;
